import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('userActions');

class ConfirmationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.confirmationActions = [
      <FlatButton label={locale.getMsg('no')} primary onClick={this.handleCancel} />,
      <RaisedButton label={locale.getMsg('yes')} primary onClick={this.handleConfirm} />,
    ];
  }
  handleCancel = () => {
    this.props.handleCancel();
  };

  handleConfirm = () => {
    this.props.handleConfirm();
  };

  open = () => {
    this.setState({
      isShown: true,
    });
  };

  mainAction = () => {};

  render() {
    const open = this.props.open;
    let confirmationActions = [];
    if (this.props.isInformational) {
      confirmationActions.push(<RaisedButton label={locale.getMsg('ok')} primary onClick={this.handleCancel} />);
    } else {
      confirmationActions = this.confirmationActions;
    }

    return (
      <Dialog title={this.props.title} actions={confirmationActions} modal open={open}>
        {this.props.text}
      </Dialog>
    );
  }
}

ConfirmationDialog.defaultProps = {
  isInformational: false,
  handleConfirm: () => {},
};

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  isInformational: PropTypes.bool,
};

export default ConfirmationDialog;
